import * as React from 'react';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker as MDatePicker } from 'material-ui-pickers';

export class DatePicker extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = { value: props.value }

        this.handleChange = this.handleChange.bind(this);
    }

    public componentWillReceiveProps(props: Props) {
        if (props.value != null) {
            this.setState({ value: props.value });
        }
    }

    private handleChange(newValue: Date) {
        this.setState({ value: newValue });
        if (this.props.onChange != null) {
            this.props.onChange(newValue);
        }
    }

    public render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <MDatePicker 
                value={this.state.value} 
                onChange={this.handleChange} 
                label={this.props.label} 
                error={this.props.error != null} 
                helperText={this.props.error != null ? this.props.error : this.props.desc} 
                format={"yyyy-MM-dd"}
                style={{width: '100%', marginBottom: '24px'}}
                />
            </MuiPickersUtilsProvider>
        );
    }

}

export interface Props {

    label: string;
    value?: Date;
    desc?: string;
    error?: string;
    onChange?: { (newValue: Date): void }

}

interface State {

    value: Date;

}